import type { CSSProperties } from 'react';
import { tokens } from '@/design';

export function attributeInputStyle(): CSSProperties {
  return {
    minHeight: tokens.density.touchMin,
    background: tokens.color.surface[2],
    color: tokens.color.ink.primary,
    border: `${tokens.border.width.thin}px solid ${tokens.color.surface[3]}`,
    borderRadius: tokens.radius.input,
    paddingInline: tokens.space[2],
    fontFamily: tokens.font.family.ui,
    fontSize: tokens.font.size.sm,
    width: '100%',
  };
}
